export default () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fill="currentColor"
      d="M17.54 2.23L16.15 0.55C15.88 0.21 15.47 0 15 0H3C2.53 0 2.12 0.21 1.84 0.55L0.46 2.23C0.17 2.57 0 3.02 0 3.5V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V3.5C18 3.02 17.83 2.57 17.54 2.23ZM3.24 2H14.76L15.57 2.97H2.44L3.24 2ZM2 16V5H16V16H2ZM10.45 8.45C10.45 7.64919 9.80081 7 9 7C8.19919 7 7.55 7.64919 7.55 8.45V10H7.41421C6.52331 10 6.07714 11.0771 6.70711 11.7071L8.29289 13.2929C8.68342 13.6834 9.31658 13.6834 9.70711 13.2929L11.2929 11.7071C11.9229 11.0771 11.4767 10 10.5858 10H10.45V8.45Z"
    />
  </svg>
);
